import script from "./TemplateBGSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./TemplateBGSelector.vue?vue&type=script&setup=true&lang=js"

import "./TemplateBGSelector.vue?vue&type=style&index=0&id=4fd4761c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fd4761c"]])

export default __exports__